module.exports = __webpack_public_path__ + "img/banner3.686bd72a.jpg";